import {
    Spin,
} from "antd";
import {auth} from "./base";
import {
    signInWithEmailAndPassword,
    onAuthStateChanged,
    signOut,
} from "firebase/auth";
import {useEffect, useState} from "react";
import {Navigate, Routes, Route} from "react-router-dom";
import NotificationPage from "./Notification";
import LoginPage from "./Login";
import AllNotificationPage from "./AllNotifications";
import TermsPage from "./termini-condizioni-app";
import PrivacyPage from "./informativa-privacy-app";
import SupportPage from "./supporto";
import CancellaAccount from "./cancella-account-app";
import RapportoEuroPunti from "./rapportoEuroPunti";
import Transazioni from "./pages/Transazioni";
import {QueryClient, QueryClientProvider, useQueryClient} from "@tanstack/react-query";
import GiftCards from "./pages/GiftCards";
import Utenti from "./pages/Utenti";
import Obiettivi from "./pages/Obiettivi";

const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
};

const App = () => {
    const [loggato, setLoggato] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                setLoggato(true);
                setLoading(false);
            } else {
                setLoading(false);
            }
        });
    }, []);

    const queryClient = new QueryClient()

    if (loading)
        return (
            <div className="absolute-center">
                <Spin/>
            </div>
        );


    return (
        <QueryClientProvider client={queryClient}>
            <Routes>
                <Route
                    path="/"
                    element={
                        loggato ? <AllNotificationPage/> : <Navigate replace to="/login"/>
                    }
                />
                <Route
                    path="/crea-notifica"
                    element={
                        loggato ? <NotificationPage/> : <Navigate replace to="/login"/>
                    }
                />
                <Route
                    path="/login"
                    element={loggato ? <Navigate replace to="/"/> : <LoginPage/>}
                />
                <Route path="/termini-condizioni" element={<TermsPage/>}/>
                <Route path="/elimina-account" element={<CancellaAccount/>}/>
                <Route path="/informativa-privacy" element={<PrivacyPage/>}/>
                <Route path="/supporto" element={<SupportPage/>}/>
                <Route path="/rapportoEuroPunti" element={<RapportoEuroPunti/>}/>
                <Route path="/transazioni" element={<Transazioni/>}/>
                <Route path="/utenti" element={<Utenti/>}/>
                <Route path="/gift-cards" element={<GiftCards/>}/>
                <Route path="/obiettivi" element={loggato ? <Obiettivi/> : <Navigate replace to="/login"/>}/>
            </Routes>
        </QueryClientProvider>
    );
};
export default App;
